import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import brandLogo from 'assets/img/logos/widestnet-logo-dark.png';

const FooterStandard = () => {
  return (
    <footer className="wn-footer">
      <Container>
        <div className="wn-footer-grid">
          <div className="wn-footer-brand">
            <img src={brandLogo} alt="Widest Net Technologies" />
            <p>
              Your fractional Chief Automation Officer. AI, automation, and
              ecommerce implementation for legacy distributors, CPG companies,
              and family-owned businesses — with the change management that
              makes it stick.
            </p>
          </div>

          <div className="wn-footer-col">
            <h4>Services</h4>
            <ul>
              <li>
                <a href="#services">Finance Operations</a>
              </li>
              <li>
                <a href="#services">Product Optimization</a>
              </li>
              <li>
                <a href="#services">E-Commerce Sales</a>
              </li>
              <li>
                <a href="#services">AI Implementation</a>
              </li>
            </ul>
          </div>

          <div className="wn-footer-col">
            <h4>Company</h4>
            <ul>
              <li>
                <a href="#about">About Us</a>
              </li>
              <li>
                <a href="#principals">Principals</a>
              </li>
              <li>
                <a href="#results">Case Studies</a>
              </li>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
            </ul>
          </div>

          <div className="wn-footer-col">
            <h4>Resources</h4>
            <ul>
              <li>
                <Link to="/demo">Demo Sandbox</Link>
              </li>
              <li>
                <Link to="/blog/ai-for-legacy-distributors-where-to-start">
                  AI for Distributors
                </Link>
              </li>
              <li>
                <a href="#contact">Contact Us</a>
              </li>
              <li>
                <a href="#contact">Free Assessment</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="wn-footer-bottom">
          <span>
            © {new Date().getFullYear()} Widest Net Technologies, LLC. All
            rights reserved.
          </span>
          <a
            href="#"
            onClick={e => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            Back to top ↑
          </a>
        </div>
      </Container>
    </footer>
  );
};

export default FooterStandard;
